exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".g-rotate-bar{position:absolute;bottom:30px;left:0;right:0;text-align:center}.g-rotate-bar .svg-icon{display:inline-block;width:1.2em;height:1.2em;margin:0 2em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e5a3b406","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/vue-core-image-upload/dist/rotate-bar.vue
// module id = 83LF
// module chunks = 25